module.exports = __webpack_public_path__ + "img/Munich_RE.b92df130.jpg";